export const isZestyCoDomain = (): boolean => {
	const desiredDomain = 'https://app.zesty.co';
	const currentUrl = globalThis.location.href;

	return currentUrl.startsWith(desiredDomain);
};
